import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-all-paid-or-pending-payment',
  templateUrl: './all-paid-or-pending-payment.component.html',
  styleUrls: ['./all-paid-or-pending-payment.component.scss']
})
export class AllPaidOrPendingPaymentComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AllPaidOrPendingPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    
  }

  ngOnInit(): void {
  }

  onClose(event) {

    this.dialogRef.close();
  }

}
